// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * @license
 * Copyright 2017 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

.neuroglancer-position-widget {
  display: inline-flex;
  align-items: center;
}

/* In Firefox, disabled input elements block all pointer events, even on parent elements, and that
interferes with our click handling.  Setting \`pointer-events: none;\` avoids that problem. */
.neuroglancer-position-widget input:disabled {
  pointer-events: none;
}

.neuroglancer-position-widget .neuroglancer-copy-button:first-child {
  display: none;
}

.neuroglancer-position-dimension-coordinate,
.neuroglancer-position-dimension-name,
.neuroglancer-position-dimension-scale {
  background-color: transparent;
  border-color: transparent;
  box-shadow: none;
  border: 0;
  margin: 0;
  font-family: monospace;
  font-size: medium;
}

.neuroglancer-position-dimension[data-coordinate-array="valid"]
  .neuroglancer-position-dimension-scale {
  display: none;
}

.neuroglancer-position-dimension[data-coordinate-array="invalid"]
  .neuroglancer-position-dimension-scale {
  text-decoration-line: underline;
  text-decoration-style: wavy;
  text-decoration-color: red;
}

.neuroglancer-position-dimension-coordinate {
  color: white;
  text-align: right;
}

.neuroglancer-position-widget input:invalid,
.neuroglancer-position-widget input::placeholder,
.neuroglancer-position-widget input[data-is-valid="false"] {
  text-decoration: solid underline red;
}

.neuroglancer-position-widget *:focus {
  outline: 0px;
}

.neuroglancer-position-dimension + .neuroglancer-position-dimension {
  margin-left: 1ch;
}

.neuroglancer-position-dimension[data-dropdown-visible="true"]::after {
  content: "";
  display: block;
  left: 0px;
  right: 0px;
  bottom: -1px;
  position: absolute;
  border-bottom: 1px solid black;
  z-index: 100;
  height: 0px;
}

.neuroglancer-position-dimension-dropdown,
.neuroglancer-position-dimension-coordinate-dropdown {
  position: absolute;
  min-width: calc(100% + 2px);
  border: 1px solid #aaa;
  box-sizing: border-box;
  padding: 2px;
  left: -1px;
  z-index: 100;
  background-color: black;
}

.neuroglancer-position-dimension-coordinate-dropdown {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.neuroglancer-dimension-dropdown-coordinate-entry {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.neuroglancer-dimension-dropdown-coordinate-entry:hover {
  background-color: #333;
}

.neuroglancer-dimension-dropdown-coordinate-label {
  width: var(--neuroglancer-coordinate-label-width);
  color: #0ff;
}

.neuroglancer-position-dimension-dropdown:focus,
.neuroglancer-position-dimension-coordinate-dropdown:focus {
  outline: 0px;
}

.neuroglancer-position-dimension:focus-within,
.neuroglancer-position-dimension[data-dropdown-visible="true"] {
  border: 1px solid #aaa;
  background-color: black;
}

.neuroglancer-position-dimension {
  border: 1px solid transparent;
  position: relative;
  display: inline-block;
  white-space: nowrap;
}

.neuroglancer-position-dimension-name {
  color: #ff6;
  padding-left: 2px;
}

.neuroglancer-position-dimension-scale-container[data-is-empty="false"]::before {
  content: "(";
  color: #aaa;
}

.neuroglancer-position-dimension-scale-container[data-is-empty="false"]::after {
  content: ")";
  color: #aaa;
}

.neuroglancer-position-dimension-scale-container[data-is-empty="false"] {
  margin-right: 5px;
}

.neuroglancer-position-dimension-scale {
  color: #bbb;
}

.neuroglancer-position-dimension-scale-container {
  margin-right: 2px;
  margin-left: 4px;
}

.neuroglancer-mouse-position-widget {
  margin-left: 1ch;
  vertical-align: center;
  font-family: monospace;
  font-size: medium;
  color: orange;
  white-space: pre;
}

.neuroglancer-position-dimension-coordinate-label {
  display: inline-block;
  color: #0ff;
}

.neuroglancer-position-dimension-coordinate-label:not(:empty)::before {
  content: "[";
  color: #aaa;
}

.neuroglancer-position-dimension-coordinate-label:not(:empty)::after {
  content: "]";
  color: #aaa;
}

.neuroglancer-position-dimension-playback {
  font-family: sans-serif;
  font-size: 10pt;
  display: flex;
  flex-direction: column;
}

.neuroglancer-position-dimension-playback .neuroglancer-number-input {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 2px;
}

.neuroglancer-position-dimension-playback input[type="text"] {
  background-color: rgba(255, 255, 255, 0.3);
  color: #fff;
  border: 0px;
  font-family: monospace;
  width: 8ch;
  text-align: right;
}

.neuroglancer-position-dimension-playback select {
  align-self: center;
}

.neuroglancer-position-dimension > .neuroglancer-icon {
  min-width: 14px;
  min-height: 14px;
  position: relative;
  top: 1px;
}

.neuroglancer-position-dimension > .neuroglancer-icon svg {
  width: 12px;
  height: 12px;
}

.neuroglancer-position-tool-in-palette {
  display: grid;
}

.neuroglancer-position-tool-in-palette > .neuroglancer-position-widget {
  grid-row: 1;
  grid-column: 1;
}

.neuroglancer-position-tool-in-palette > .neuroglancer-position-dimension-plot {
  grid-row: 2;
  grid-column: 1 / 10;
}

.neuroglancer-position-tool-in-palette > .neuroglancer-checkbox-icon {
  grid-row: 1;
  grid-column: 9;
}

.neuroglancer-position-tool {
  background-color: #474747;
  display: flex;
  flex-direction: row;
}

.neuroglancer-position-dimension-playback-header {
  display: flex;
  flex-direction: row;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./node_modules/neuroglancer/lib/widget/position_widget.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;2FAC2F;AAC3F;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;EACT,SAAS;EACT,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,SAAS;EACT,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,2BAA2B;EAC3B,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iDAAiD;EACjD,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":["/**\n * @license\n * Copyright 2017 Google Inc.\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *      http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\n.neuroglancer-position-widget {\n  display: inline-flex;\n  align-items: center;\n}\n\n/* In Firefox, disabled input elements block all pointer events, even on parent elements, and that\ninterferes with our click handling.  Setting `pointer-events: none;` avoids that problem. */\n.neuroglancer-position-widget input:disabled {\n  pointer-events: none;\n}\n\n.neuroglancer-position-widget .neuroglancer-copy-button:first-child {\n  display: none;\n}\n\n.neuroglancer-position-dimension-coordinate,\n.neuroglancer-position-dimension-name,\n.neuroglancer-position-dimension-scale {\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: none;\n  border: 0;\n  margin: 0;\n  font-family: monospace;\n  font-size: medium;\n}\n\n.neuroglancer-position-dimension[data-coordinate-array=\"valid\"]\n  .neuroglancer-position-dimension-scale {\n  display: none;\n}\n\n.neuroglancer-position-dimension[data-coordinate-array=\"invalid\"]\n  .neuroglancer-position-dimension-scale {\n  text-decoration-line: underline;\n  text-decoration-style: wavy;\n  text-decoration-color: red;\n}\n\n.neuroglancer-position-dimension-coordinate {\n  color: white;\n  text-align: right;\n}\n\n.neuroglancer-position-widget input:invalid,\n.neuroglancer-position-widget input::placeholder,\n.neuroglancer-position-widget input[data-is-valid=\"false\"] {\n  text-decoration: solid underline red;\n}\n\n.neuroglancer-position-widget *:focus {\n  outline: 0px;\n}\n\n.neuroglancer-position-dimension + .neuroglancer-position-dimension {\n  margin-left: 1ch;\n}\n\n.neuroglancer-position-dimension[data-dropdown-visible=\"true\"]::after {\n  content: \"\";\n  display: block;\n  left: 0px;\n  right: 0px;\n  bottom: -1px;\n  position: absolute;\n  border-bottom: 1px solid black;\n  z-index: 100;\n  height: 0px;\n}\n\n.neuroglancer-position-dimension-dropdown,\n.neuroglancer-position-dimension-coordinate-dropdown {\n  position: absolute;\n  min-width: calc(100% + 2px);\n  border: 1px solid #aaa;\n  box-sizing: border-box;\n  padding: 2px;\n  left: -1px;\n  z-index: 100;\n  background-color: black;\n}\n\n.neuroglancer-position-dimension-coordinate-dropdown {\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.neuroglancer-dimension-dropdown-coordinate-entry {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.neuroglancer-dimension-dropdown-coordinate-entry:hover {\n  background-color: #333;\n}\n\n.neuroglancer-dimension-dropdown-coordinate-label {\n  width: var(--neuroglancer-coordinate-label-width);\n  color: #0ff;\n}\n\n.neuroglancer-position-dimension-dropdown:focus,\n.neuroglancer-position-dimension-coordinate-dropdown:focus {\n  outline: 0px;\n}\n\n.neuroglancer-position-dimension:focus-within,\n.neuroglancer-position-dimension[data-dropdown-visible=\"true\"] {\n  border: 1px solid #aaa;\n  background-color: black;\n}\n\n.neuroglancer-position-dimension {\n  border: 1px solid transparent;\n  position: relative;\n  display: inline-block;\n  white-space: nowrap;\n}\n\n.neuroglancer-position-dimension-name {\n  color: #ff6;\n  padding-left: 2px;\n}\n\n.neuroglancer-position-dimension-scale-container[data-is-empty=\"false\"]::before {\n  content: \"(\";\n  color: #aaa;\n}\n\n.neuroglancer-position-dimension-scale-container[data-is-empty=\"false\"]::after {\n  content: \")\";\n  color: #aaa;\n}\n\n.neuroglancer-position-dimension-scale-container[data-is-empty=\"false\"] {\n  margin-right: 5px;\n}\n\n.neuroglancer-position-dimension-scale {\n  color: #bbb;\n}\n\n.neuroglancer-position-dimension-scale-container {\n  margin-right: 2px;\n  margin-left: 4px;\n}\n\n.neuroglancer-mouse-position-widget {\n  margin-left: 1ch;\n  vertical-align: center;\n  font-family: monospace;\n  font-size: medium;\n  color: orange;\n  white-space: pre;\n}\n\n.neuroglancer-position-dimension-coordinate-label {\n  display: inline-block;\n  color: #0ff;\n}\n\n.neuroglancer-position-dimension-coordinate-label:not(:empty)::before {\n  content: \"[\";\n  color: #aaa;\n}\n\n.neuroglancer-position-dimension-coordinate-label:not(:empty)::after {\n  content: \"]\";\n  color: #aaa;\n}\n\n.neuroglancer-position-dimension-playback {\n  font-family: sans-serif;\n  font-size: 10pt;\n  display: flex;\n  flex-direction: column;\n}\n\n.neuroglancer-position-dimension-playback .neuroglancer-number-input {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: 2px;\n}\n\n.neuroglancer-position-dimension-playback input[type=\"text\"] {\n  background-color: rgba(255, 255, 255, 0.3);\n  color: #fff;\n  border: 0px;\n  font-family: monospace;\n  width: 8ch;\n  text-align: right;\n}\n\n.neuroglancer-position-dimension-playback select {\n  align-self: center;\n}\n\n.neuroglancer-position-dimension > .neuroglancer-icon {\n  min-width: 14px;\n  min-height: 14px;\n  position: relative;\n  top: 1px;\n}\n\n.neuroglancer-position-dimension > .neuroglancer-icon svg {\n  width: 12px;\n  height: 12px;\n}\n\n.neuroglancer-position-tool-in-palette {\n  display: grid;\n}\n\n.neuroglancer-position-tool-in-palette > .neuroglancer-position-widget {\n  grid-row: 1;\n  grid-column: 1;\n}\n\n.neuroglancer-position-tool-in-palette > .neuroglancer-position-dimension-plot {\n  grid-row: 2;\n  grid-column: 1 / 10;\n}\n\n.neuroglancer-position-tool-in-palette > .neuroglancer-checkbox-icon {\n  grid-row: 1;\n  grid-column: 9;\n}\n\n.neuroglancer-position-tool {\n  background-color: #474747;\n  display: flex;\n  flex-direction: row;\n}\n\n.neuroglancer-position-dimension-playback-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
